export const HotmartAIEndpoints = {
  createCompletion: () => '/v1/completions',
  getCompletion: (uuid: string) => `/v1/completions/${uuid}`
}
